import { Avatar } from "@mui/material";
import { User } from "datasheets/model/core/User";

interface BDProps {
  user: User;
  onClick: React.MouseEventHandler | undefined;
}

export function BDAvatar(props: BDProps) {
  return (
    <Avatar
      {...stringAvatar(props.user.name)}
      role="avatar"
      onClick={props.onClick}
    />
  );
}

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name: string) {
  let initials = name
    .split(" ")
    .map((part) => (part.length > 0 ? part[0] : ""))
    .join("");
  // limit to size 3
  if (initials.length > 3) {
    initials = initials[0] + initials[1] + initials[initials.length - 1];
  }
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${initials}`,
  };
}
